import AlbumCover from '../BannermasApr19/AlbumCover.jpg'
import IMG1 from '../BannermasApr19/A2IMG20190401203350.jpg'
import IMG2 from '../BannermasApr19/BICE2198.jpg'
import IMG3 from '../BannermasApr19/BICE2212.jpg'
import IMG4 from '../BannermasApr19/BICE2218.jpg'
import IMG5 from '../BannermasApr19/BICE2220.jpg'
import IMG6 from '../BannermasApr19/BICE2237.jpg'
import IMG7 from '../BannermasApr19/BICE2267.jpg'
import IMG8 from '../BannermasApr19/BICE2271.jpg'
import IMG9 from '../BannermasApr19/BICE2274.jpg'
import IMG10 from '../BannermasApr19/BICE2279.jpg'
import IMG11 from '../BannermasApr19/BICE2281.jpg'
import IMG12 from '../BannermasApr19/BICE2289.jpg'
import IMG13 from '../BannermasApr19/BICE2302.jpg'
import IMG14 from '../BannermasApr19/BICE2314.jpg'
import IMG15 from '../BannermasApr19/BICE2320.jpg'
import IMG16 from '../BannermasApr19/BICE2333.jpg'
import IMG17 from '../BannermasApr19/BICE2348.jpg'
import IMG18 from '../BannermasApr19/BICE2352.jpg'
import IMG19 from '../BannermasApr19/BICE2353.jpg'
import IMG20 from '../BannermasApr19/BICE2372.jpg'
import IMG21 from '../BannermasApr19/BICE2378.jpg'
import IMG22 from '../BannermasApr19/image001.jpg'
import IMG23 from '../BannermasApr19/image002.jpg'
import IMG24 from '../BannermasApr19/image003.jpg'
import IMG25 from '../BannermasApr19/image005.jpg'
import IMG26 from '../BannermasApr19/image007.jpg'
import IMG27 from '../BannermasApr19/image008.jpg'
import IMG28 from '../BannermasApr19/image009.jpg'
import IMG29 from '../BannermasApr19/image010.jpg'
import IMG30 from '../BannermasApr19/image011.jpg'
import IMG31 from '../BannermasApr19/image012.jpg'
import IMG32 from '../BannermasApr19/image013.jpg'
import IMG33 from '../BannermasApr19/image014.jpg'
import IMG34 from '../BannermasApr19/IMG20190405215640.jpg'
import IMG35 from '../BannermasApr19/IMG20190405221449.jpg'
import IMG36 from '../BannermasApr19/IMG20190406232600.jpg'
import IMG37 from '../BannermasApr19/IMG20190412163349.jpg'
import IMG38 from '../BannermasApr19/IMG20190412163703.jpg'

export const BannermasApr19List = [
  AlbumCover,
  IMG1,
  IMG2,
  IMG3,
  IMG4,
  IMG5,
  IMG6,
  IMG7,
  IMG8,
  IMG9,
  IMG10,
  IMG11,
  IMG12,
  IMG13,
  IMG14,
  IMG15,
  IMG16,
  IMG17,
  IMG18,
  IMG19,
  IMG20,
  IMG21,
  IMG22,
  IMG23,
  IMG24,
  IMG25,
  IMG26,
  IMG27,
  IMG28,
  IMG29,
  IMG30,
  IMG31,
  IMG32,
  IMG33,
  IMG34,
  IMG35,
  IMG36,
  IMG37,
  IMG38,
];
